import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-mask',
  standalone: true,
  imports: [NgIf],
  templateUrl: './mask.component.html',
  styleUrl: './mask.component.scss',
})
export class MaskComponent {
  @Input() visible = true;
  @Input() level = 0;
  @Input() isLoadingScreen = false;
}
